// src/components/common/Layout/Navigation.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { COLORS } from '../../../utils/constants';
import './Navigation.css';

const Navigation = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [activePage, setActivePage] = useState('dashboard');

  // Update active page based on current route
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/dashboard')) setActivePage('dashboard');
    else if (path.includes('/stocks') || path.includes('/investment')) setActivePage('stocks');
    else if (path.includes('/portfolio')) setActivePage('portfolio');
    else if (path.includes('/profile')) setActivePage('profile');
  }, [location]);

  const handleLogout = () => {
    logout();
  };

  const navigationItems = [
    { key: 'dashboard', label: 'Home', symbolClass: 'home', path: '/dashboard' },
    { key: 'stocks', label: 'Assets', symbolClass: 'stocks', path: '/stocks' },
    { key: 'portfolio', label: 'Portfolio', symbolClass: 'portfolio', path: '/portfolio' },
    { key: 'profile', label: 'Profile', symbolClass: 'profile', path: '/profile' },
  ];

  const handleNavigation = (key, path) => {
    setActivePage(key);
    navigate(path);
  };

  return (
    <>
      {/* Desktop Sidebar */}
      <nav className="desktop-nav">
        <div className="nav-brand">
          <h2>TREXAR</h2>
        </div>
        
        <div className="nav-items">
          {navigationItems.map((item) => (
            <button
              key={item.key}
              className={`nav-item ${activePage === item.key ? 'active' : ''}`}
              onClick={() => handleNavigation(item.key, item.path)}
              style={{
                backgroundColor: activePage === item.key ? COLORS.PRIMARY : 'transparent',
                color: activePage === item.key ? COLORS.WHITE : COLORS.TEXT
              }}
            >
              {/* Geometric Symbol for Desktop */}
              <div className={`nav-symbol ${item.symbolClass}`}></div>
              <span className="nav-label">{item.label}</span>
            </button>
          ))}
        </div>
        
        <div className="nav-user">
          {user && (
            <div className="user-section">
              <div className="user-info">
                {/* Profile symbol for user avatar */}
                <div className="nav-symbol profile" style={{ width: '32px', height: '32px' }}></div>
                <span className="user-name">Welcome, {user.username}</span>
              </div>
              <button 
                onClick={handleLogout}
                className="logout-button"
                style={{ 
                  backgroundColor: COLORS.PRIMARY,
                  color: COLORS.WHITE
                }}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* Mobile Bottom Navigation - OPAY STYLE */}
      <nav className="mobile-nav">
        {navigationItems.map((item) => (
          <button
            key={item.key}
            className={`mobile-nav-item ${activePage === item.key ? 'active' : ''}`}
            onClick={() => handleNavigation(item.key, item.path)}
            style={{
              color: activePage === item.key ? COLORS.PRIMARY : '#999999'
            }}
          >
            {/* Geometric Symbol instead of emoji */}
            <div className={`nav-symbol ${item.symbolClass}`}></div>
            <span className="mobile-nav-label">{item.label}</span>
          </button>
        ))}
      </nav>
    </>
  );
};

export default Navigation;